var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "groupBooking f16" },
    [
      _c("div", { staticClass: "lin_15 f16 gray_3 fb" }, [
        _vm._v("\n      拼团策略 - 添加拼团\n    ")
      ]),
      _c("div", { staticClass: "box20" }),
      _c("div", { staticClass: " t_right" }, [
        _c(
          "span",
          {
            staticClass: "group_btn b_red white f16 t_center",
            on: { click: _vm.toGroupList }
          },
          [_vm._v("返回活动列表")]
        )
      ]),
      _c("div", { staticClass: "box20" }),
      _c(
        "div",
        [
          _c("p", { staticClass: "ps_main_head" }, [
            _vm._v("温馨提示：最终的价格，以商品列表计算后展示的价格为准")
          ]),
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.activity,
                rules: _vm.rules,
                "label-width": "160px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "拼团活动名称", prop: "title" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "35" },
                    model: {
                      value: _vm.activity.title,
                      callback: function($$v) {
                        _vm.$set(_vm.activity, "title", $$v)
                      },
                      expression: "activity.title"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "活动时间" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "datetimerange",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "default-time": ["00:00:00", "23:59:59"],
                      "picker-options": _vm.pickerOptions
                    },
                    model: {
                      value: _vm.activity.date,
                      callback: function($$v) {
                        _vm.$set(_vm.activity, "date", $$v)
                      },
                      expression: "activity.date"
                    }
                  }),
                  _c("span", { staticClass: "pad30_l red f12" }, [
                    _vm._v("提示：活动结束，活动商品自动转为原价")
                  ])
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "拼团类型" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      staticClass: "groupType",
                      model: {
                        value: _vm.activity.groupType,
                        callback: function($$v) {
                          _vm.$set(_vm.activity, "groupType", $$v)
                        },
                        expression: "activity.groupType"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 1, border: "" } }, [
                        _vm._v("促活团\n              "),
                        _c("p", { staticClass: "pad10_t" }, [
                          _vm._v("该团适用于店铺促活，全部用户")
                        ]),
                        _c("p", [_vm._v("均可参与")])
                      ]),
                      _c("el-radio", { attrs: { label: 2, border: "" } }, [
                        _vm._v("拉新团\n              "),
                        _c("p", { staticClass: "pad10_t" }, [
                          _vm._v("该团使用店铺拉新，仅限新用户")
                        ]),
                        _c("p", [_vm._v("(仅在商城下单的用户)参与")])
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "活动商品" } }, [
                _c(
                  "span",
                  {
                    staticClass: "group_btn b_red white f14 t_center",
                    on: { click: _vm.selectGoodsList }
                  },
                  [_vm._v("点击添加商品")]
                )
              ]),
              _vm.checkGoodsList.length
                ? _c(
                    "el-table",
                    {
                      ref: "multipleTable",
                      staticClass: "mar20_b",
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.checkGoodsList,
                        "tooltip-effect": "dark"
                      },
                      on: { "selection-change": _vm.handleSelectionChange }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "name", label: "货品名称", width: "180" }
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "spec", label: "规格", width: "80" }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "marketPriceStr",
                          label: "原价(元)",
                          width: "90"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: { label: "拼团价", width: "100" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("el-input", {
                                    on: {
                                      blur: function($event) {
                                        scope.row.goodsPrice = _vm.formatNums(
                                          scope.row.goodsPrice,
                                          true
                                        )
                                      }
                                    },
                                    model: {
                                      value: scope.row.goodsPrice,
                                      callback: function($$v) {
                                        _vm.$set(scope.row, "goodsPrice", $$v)
                                      },
                                      expression: "scope.row.goodsPrice"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          329433691
                        )
                      }),
                      _c("el-table-column", {
                        attrs: { label: "团长价", width: "100" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("el-input", {
                                    on: {
                                      blur: function($event) {
                                        scope.row.sponsorPrice = _vm.formatNums(
                                          scope.row.sponsorPrice,
                                          true
                                        )
                                      }
                                    },
                                    model: {
                                      value: scope.row.sponsorPrice,
                                      callback: function($$v) {
                                        _vm.$set(scope.row, "sponsorPrice", $$v)
                                      },
                                      expression: "scope.row.sponsorPrice"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3369547271
                        )
                      }),
                      _c("el-table-column", {
                        attrs: { label: "成团人数", width: "110" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("el-input", {
                                    on: {
                                      blur: function($event) {
                                        scope.row.peopleLimit = _vm.formatNums(
                                          scope.row.peopleLimit,
                                          false
                                        )
                                      }
                                    },
                                    model: {
                                      value: scope.row.peopleLimit,
                                      callback: function($$v) {
                                        _vm.$set(scope.row, "peopleLimit", $$v)
                                      },
                                      expression: "scope.row.peopleLimit"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2346277403
                        )
                      }),
                      _c("el-table-column", {
                        attrs: { label: "活动商品数", width: "100" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("el-input", {
                                    on: {
                                      blur: function($event) {
                                        scope.row.goodsQuantity = _vm.formatNums(
                                          scope.row.goodsQuantity,
                                          true
                                        )
                                      }
                                    },
                                    model: {
                                      value: scope.row.goodsQuantity,
                                      callback: function($$v) {
                                        _vm.$set(
                                          scope.row,
                                          "goodsQuantity",
                                          $$v
                                        )
                                      },
                                      expression: "scope.row.goodsQuantity"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2845041069
                        )
                      }),
                      _c("el-table-column", {
                        attrs: { label: "限制开团次数", width: "120" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("el-input", {
                                    on: {
                                      blur: function($event) {
                                        scope.row.volumeLimit = _vm.formatNums(
                                          scope.row.volumeLimit,
                                          false
                                        )
                                      }
                                    },
                                    model: {
                                      value: scope.row.volumeLimit,
                                      callback: function($$v) {
                                        _vm.$set(scope.row, "volumeLimit", $$v)
                                      },
                                      expression: "scope.row.volumeLimit"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1440027568
                        )
                      }),
                      _c("el-table-column", {
                        attrs: { label: "操作" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "red cursor",
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteRow(
                                            scope.$index,
                                            _vm.checkGoodsList
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("删除")]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1837469510
                        )
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "是否设置团长福利" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.activity.activityDtl.sponsorRewardType,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.activity.activityDtl,
                            "sponsorRewardType",
                            $$v
                          )
                        },
                        expression: "activity.activityDtl.sponsorRewardType"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("无")]),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("优惠券")
                      ])
                    ],
                    1
                  ),
                  _vm.activity.activityDtl.sponsorRewardType === 2
                    ? _c("span", { staticClass: "pad30_l red f12" }, [
                        _vm._v(
                          "提示：拼团成功后，默认为团长生成一笔当前商品0元的订单，请及时发货"
                        )
                      ])
                    : _vm._e(),
                  _vm.activity.activityDtl.sponsorRewardType === 1
                    ? _c("div", [
                        _c(
                          "span",
                          {
                            staticClass: "group_btn b_red white f14 t_center",
                            on: {
                              click: function($event) {
                                return _vm.chooseCoupon(
                                  _vm.checkCouponList,
                                  false
                                )
                              }
                            }
                          },
                          [_vm._v("点击选择优惠券")]
                        ),
                        _c("div", { staticClass: "mar20_t coupon_list" }, [
                          _c(
                            "ul",
                            { staticClass: "clear f12 white" },
                            _vm._l(_vm.checkCouponList, function(
                              coupon,
                              index
                            ) {
                              return _c("li", { key: coupon.regCode }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "coupon_delete",
                                    on: {
                                      click: function($event) {
                                        return _vm.removeCheckCoupon(
                                          index,
                                          _vm.checkCouponList
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "iconfont icon-iconfontshibai red f15"
                                    })
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "clear coupon_price" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "float-left f24 lin_30" },
                                      [_vm._v(_vm._s(coupon.regVal))]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "float-right t_right" },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            "满" +
                                              _vm._s(coupon.regKey) +
                                              "元可用"
                                          )
                                        ]),
                                        coupon.busType === "SHOP"
                                          ? _c("p", [_vm._v("全部货品可用")])
                                          : _vm._e(),
                                        coupon.busType === "GOODS"
                                          ? _c("p", [_vm._v("指定货品可用")])
                                          : _vm._e(),
                                        coupon.busType === "CATE"
                                          ? _c("p", [_vm._v("指定分类可用")])
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                ),
                                _c("p", { staticClass: "t_center" }, [
                                  _vm._v(
                                    "领取时间：" +
                                      _vm._s(coupon.startTimeStr) +
                                      "至" +
                                      _vm._s(coupon.endTimeStr)
                                  )
                                ]),
                                _c("p", { staticClass: "t_center" }, [
                                  _vm._v(
                                    "使用时间：" +
                                      _vm._s(coupon.useStartTimeStr) +
                                      "至" +
                                      _vm._s(coupon.useEndTimeStr)
                                  )
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "clear coupon_num gray_3" },
                                  [
                                    _c("p", { staticClass: "float-left" }, [
                                      _vm._v("数量："),
                                      _c("em", { staticClass: "red" }, [
                                        _vm._v(_vm._s(coupon.surplusNum))
                                      ])
                                    ]),
                                    coupon.residueEndDay
                                      ? _c(
                                          "p",
                                          { staticClass: "float-right" },
                                          [_vm._v("即将到期")]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ])
                            }),
                            0
                          )
                        ])
                      ])
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "拼团失败补偿" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.activity.activityDtl.failRewardType,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.activity.activityDtl,
                            "failRewardType",
                            $$v
                          )
                        },
                        expression: "activity.activityDtl.failRewardType"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("无")]),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("优惠券")
                      ])
                    ],
                    1
                  ),
                  _vm.activity.activityDtl.failRewardType === 1
                    ? _c("div", [
                        _c(
                          "span",
                          {
                            staticClass: "group_btn b_red white f14 t_center",
                            on: {
                              click: function($event) {
                                return _vm.chooseCoupon(
                                  _vm.compensationCouponList,
                                  true
                                )
                              }
                            }
                          },
                          [_vm._v("点击选择优惠券")]
                        ),
                        _c("div", { staticClass: "mar20_t coupon_list" }, [
                          _c(
                            "ul",
                            { staticClass: "clear f12 white" },
                            _vm._l(_vm.compensationCouponList, function(
                              coupon,
                              index
                            ) {
                              return _c("li", { key: coupon.regCode }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "coupon_delete",
                                    on: {
                                      click: function($event) {
                                        return _vm.removeCheckCoupon(
                                          index,
                                          _vm.compensationCouponList
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "iconfont icon-iconfontshibai red f15"
                                    })
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "clear coupon_price" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "float-left f24 lin_30" },
                                      [_vm._v(_vm._s(coupon.regVal))]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "float-right t_right" },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            "满" +
                                              _vm._s(coupon.regKey) +
                                              "元可用"
                                          )
                                        ]),
                                        coupon.busType === "SHOP"
                                          ? _c("p", [_vm._v("全部货品可用")])
                                          : _vm._e(),
                                        coupon.busType === "GOODS"
                                          ? _c("p", [_vm._v("指定货品可用")])
                                          : _vm._e(),
                                        coupon.busType === "CATE"
                                          ? _c("p", [_vm._v("指定分类可用")])
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                ),
                                _c("p", { staticClass: "t_center" }, [
                                  _vm._v(
                                    "领取时间：" +
                                      _vm._s(coupon.startTimeStr) +
                                      "至" +
                                      _vm._s(coupon.endTimeStr)
                                  )
                                ]),
                                _c("p", { staticClass: "t_center" }, [
                                  _vm._v(
                                    "使用时间：" +
                                      _vm._s(coupon.useStartTimeStr) +
                                      "至" +
                                      _vm._s(coupon.useEndTimeStr)
                                  )
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "clear coupon_num gray_3" },
                                  [
                                    _c("p", { staticClass: "float-left" }, [
                                      _vm._v("数量："),
                                      _c("em", { staticClass: "red" }, [
                                        _vm._v(_vm._s(coupon.surplusNum))
                                      ])
                                    ]),
                                    coupon.residueEndDay
                                      ? _c(
                                          "p",
                                          { staticClass: "float-right" },
                                          [_vm._v("即将到期")]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ])
                            }),
                            0
                          )
                        ])
                      ])
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "分享图片" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "share-uploader",
                      attrs: {
                        action: "https://upload-z2.qiniup.com/",
                        "show-file-list": false,
                        "on-success": _vm.shareSuccess,
                        "before-upload": _vm.shareBeforeUpload,
                        data: _vm.postData
                      }
                    },
                    [
                      _vm.shareImageUrl
                        ? _c("img", {
                            staticClass: "avatar",
                            attrs: { src: _vm.shareImageUrl }
                          })
                        : _c("i", {
                            staticClass: "el-icon-plus avatar-uploader-icon"
                          })
                    ]
                  ),
                  _c("p", { staticClass: "f12 gray_9 lin_20" }, [
                    _vm._v("当前为默认图片，若需自定义，可点击图片进行更换")
                  ]),
                  _c("p", { staticClass: "f12 gray_9 lin_20" }, [
                    _vm._v(
                      "文件格式jpg、png，文件大小300KB以内，建议尺寸750px*600px"
                    )
                  ])
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "顶部宣传图" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "top-uploader",
                      attrs: {
                        action: "https://upload-z2.qiniup.com/",
                        "show-file-list": false,
                        "on-success": _vm.topSuccess,
                        "before-upload": _vm.shareBeforeUpload,
                        data: _vm.postData
                      }
                    },
                    [
                      _vm.topImageUrl
                        ? _c("img", {
                            staticClass: "avatar",
                            attrs: { src: _vm.topImageUrl }
                          })
                        : _c("i", {
                            staticClass: "el-icon-plus avatar-uploader-icon"
                          })
                    ]
                  ),
                  _c("p", { staticClass: "f12 gray_9 lin_20" }, [
                    _vm._v("当前为默认图片，若需自定义，可点击图片进行更换")
                  ]),
                  _c("p", { staticClass: "f12 gray_9 lin_20" }, [
                    _vm._v(
                      "文件格式jpg、png，文件大小300KB以内，建议尺寸750px*600px"
                    )
                  ])
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "活动规则" } },
                [
                  _c("Tinymce", {
                    ref: "tinymce",
                    attrs: { id: "id", contentInit: _vm.contentInit }
                  })
                ],
                1
              ),
              _c("el-form-item", [
                _c(
                  "div",
                  { staticClass: "t_center" },
                  [
                    _c("el-button", { on: { click: _vm.toGroupList } }, [
                      _vm._v("取消")
                    ]),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onSubmit }
                      },
                      [_vm._v("确认")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择商品",
            visible: _vm.chooseGoodVisible,
            "close-on-click-modal": false,
            width: "1140px",
            top: "80px",
            "show-close": false,
            "custom-class": "chooseGoodPop"
          },
          on: {
            "update:visible": function($event) {
              _vm.chooseGoodVisible = $event
            }
          }
        },
        [
          _c("div", [
            _c("div", { staticClass: "clear ps_search_wrap" }, [
              _c(
                "span",
                { staticClass: "float-left pad15_r lin_30 inlineblock" },
                [_vm._v("货品名称")]
              ),
              _c(
                "div",
                { staticClass: "ps_search float-left" },
                [
                  _c("el-input", {
                    attrs: { type: "text", placeholder: "请输入货品名称" },
                    model: {
                      value: _vm.searchGoods.name,
                      callback: function($$v) {
                        _vm.$set(_vm.searchGoods, "name", $$v)
                      },
                      expression: "searchGoods.name"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "float-left client_pop_query",
                  on: {
                    click: function($event) {
                      return _vm.listShopGoods(1)
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ]),
            _c("div", { staticClass: "clear appoint_goods_list" }, [
              _c("div", { staticClass: "float-left client_list_all" }, [
                _c("p", [_vm._v("本店货品")]),
                _c("div", { staticClass: "client_list_wrap" }, [
                  _c(
                    "ul",
                    { staticClass: "clear" },
                    _vm._l(_vm.goodsDataList, function(item, index) {
                      return _c(
                        "li",
                        {
                          key: index,
                          on: {
                            click: function($event) {
                              return _vm.goodsDialogSelect(item)
                            }
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "float-left appoint_good_img",
                            attrs: { src: item.picUrl, alt: "" }
                          }),
                          _c(
                            "div",
                            { staticClass: "float-left appoint_good_main" },
                            [
                              _c("p", { staticClass: "ellipsis f14" }, [
                                _vm._v(_vm._s(item.name))
                              ]),
                              _c("p", { staticClass: "f12" }, [
                                _vm._v("规格：" + _vm._s(item.spec))
                              ]),
                              _c("p", { staticClass: "f12" }, [
                                _vm._v("原价：¥" + _vm._s(item.marketPriceStr))
                              ])
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  )
                ])
              ]),
              _c("div", { staticClass: "float-right client_list_me" }, [
                _c("p", [_vm._v("已选货品")]),
                _c("div", { staticClass: "client_list_wrap" }, [
                  _c(
                    "ul",
                    { staticClass: "clear" },
                    _vm._l(_vm.goodsSelectList, function(item, index) {
                      return _c("li", { key: index }, [
                        _c("i", {
                          staticClass: "iconfont icon-shibai fb",
                          on: {
                            click: function($event) {
                              return _vm.removeSelectGoods(index)
                            }
                          }
                        }),
                        _c("img", {
                          staticClass: "float-left appoint_good_img",
                          attrs: { src: item.picUrl, alt: "" }
                        }),
                        _c(
                          "div",
                          { staticClass: "float-left appoint_good_main" },
                          [
                            _c("p", { staticClass: "ellipsis f14" }, [
                              _vm._v(_vm._s(item.name))
                            ]),
                            _c("p", { staticClass: "f12" }, [
                              _vm._v("规格：" + _vm._s(item.spec))
                            ]),
                            _c("p", { staticClass: "f12" }, [
                              _vm._v("原价：¥" + _vm._s(item.marketPriceStr))
                            ])
                          ]
                        )
                      ])
                    }),
                    0
                  )
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "box10" }),
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 30],
              "page-size": _vm.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.totalCount
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.goodsDialogConfirm }
                },
                [_vm._v("确 认")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.chooseGoodVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择优惠券",
            visible: _vm.chooseCouponVisible,
            "close-on-click-modal": false,
            width: "540px",
            top: "120px",
            "show-close": false,
            "custom-class": "chooseCouponPop"
          },
          on: {
            "update:visible": function($event) {
              _vm.chooseCouponVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "coupon_list" }, [
            _c(
              "ul",
              { staticClass: "clear f12 white" },
              _vm._l(_vm.shopCouponList, function(coupon) {
                return coupon.surplusNum > 0
                  ? _c(
                      "li",
                      {
                        key: coupon.regCode,
                        class: { coupon_check: coupon.isCheck },
                        on: {
                          click: function($event) {
                            return _vm.checkCoupon(coupon)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "clear coupon_price" }, [
                          _c("span", { staticClass: "float-left f24" }, [
                            _vm._v("￥" + _vm._s(coupon.regVal))
                          ]),
                          _c(
                            "span",
                            { staticClass: "float-left pad5_l lin_35" },
                            [_vm._v("满" + _vm._s(coupon.regKey))]
                          )
                        ]),
                        _c("p", { staticClass: "pad20_l f14" }, [
                          _vm._v("有效期至" + _vm._s(coupon.endTimeStr))
                        ]),
                        _c("div", { staticClass: "box15" }),
                        _c("div", { staticClass: "clear coupon_num gray_3" }, [
                          coupon.busType === "SHOP"
                            ? _c("span", { staticClass: "float-left" }, [
                                _vm._v("全部货品可用")
                              ])
                            : coupon.busType === "GOODS"
                            ? _c("span", { staticClass: "float-left" }, [
                                _vm._v("指定货品可用")
                              ])
                            : coupon.busType === "CATE"
                            ? _c("span", { staticClass: "float-left" }, [
                                _vm._v("指定分类可用")
                              ])
                            : _vm._e()
                        ])
                      ]
                    )
                  : _vm._e()
              }),
              0
            )
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmCheckCoupon }
                },
                [_vm._v("确 定")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.chooseCouponVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }